import Vue from 'vue';
import IsoBookingButtonForm from './form/IsoBookingButtonForm.vue';

Vue.component('iso-booking-button-form', IsoBookingButtonForm);

function initIsoBookingButtons() {
    const modules = document.querySelectorAll('[data-iso-booking-button-module]:not([data-vb-initialized])');
    modules.forEach((element) => {
        element.setAttribute('data-vb-initialized', 'true');
        new Vue({
            el: element,
            components: {
                IsoBookingButtonForm
            }
        });
    });
}

// Initialize server-rendered instances on page load
initIsoBookingButtons();

// Initialize instances injected dynamically by Vue (e.g. v-html inside iso-booking-module tabs)
const observer = new MutationObserver(initIsoBookingButtons);
observer.observe(document.body, { childList: true, subtree: true });